import { render, staticRenderFns } from "./translation-job-summary-cards.vue?vue&type=template&id=f6c1e3cc&scoped=true"
import script from "./translation-job-summary-cards.vue?vue&type=script&lang=ts"
export * from "./translation-job-summary-cards.vue?vue&type=script&lang=ts"
import style0 from "./translation-job-summary-cards.vue?vue&type=style&index=0&id=f6c1e3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c1e3cc",
  null
  
)

export default component.exports